import {DateObject} from 'react-multi-date-picker'
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doPARTICIPANT_ISSUE_SET} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH = 'REQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH'
export const doREQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH = createDoRequestAction(
  REQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH,
)

export const requestProjectParticipantIssuesFetchActionCreators = {
  doREQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH,
}

export function* requestProjectParticipantIssuesFetch({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestProjectParticipantIssuesFetch')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        projectId: v.string().uuid().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {projectId} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/project-participant-issues-fetch`,
    accessToken,
    data: {
      projectId,
      localYymmdd: new DateObject().format('YYMMDD'),
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/project-participant-issues-fetch',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doPARTICIPANT_ISSUE_SET({
      ...result.payload,
    }),
  )

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH,
        fromPayload: payload,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* projectParticipantIssuesFetchSaga() {
  yield takeEvery(REQUEST_PROJECT_PARTICIPANT_ISSUES_FETCH, requestProjectParticipantIssuesFetch)
}
